/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    Prerequisite,
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    QuestConfigMilestone,
    QuestConfigMilestoneFromJSON,
    QuestConfigMilestoneFromJSONTyped,
    QuestConfigMilestoneToJSON,
    QuestDisplay,
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestReset,
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestConfig
 */
export interface QuestConfig {
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    updatedAt: number;
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof QuestConfig
     */
    displayedOn?: Array<QuestDisplay>;
    /**
     * Display quest to users who have not yet met prerequisites.
     * @type {boolean}
     * @memberof QuestConfig
     */
    shouldDisplayUnqualified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfig
     */
    requireProgressionOrder?: boolean;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof QuestConfig
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof QuestConfig
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and processes event logs in BE) or not.
     * @type {boolean}
     * @memberof QuestConfig
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof QuestConfig
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof QuestConfig
     */
    questCompleteNotificationMessage?: string;
    /**
     * 
     * @type {QuestReset}
     * @memberof QuestConfig
     */
    questReset: QuestReset;
    /**
     * 
     * @type {Array<QuestConfigMilestone>}
     * @memberof QuestConfig
     */
    milestones?: Array<QuestConfigMilestone>;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof QuestConfig
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestConfig
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof QuestConfig
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestConfig
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestConfig
     */
    endAt?: number;
}

export function QuestConfigFromJSON(json: any): QuestConfig {
    return QuestConfigFromJSONTyped(json, false);
}

export function QuestConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'displayedOn': !exists(json, 'displayedOn') ? undefined : ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'shouldDisplayUnqualified': !exists(json, 'shouldDisplayUnqualified') ? undefined : json['shouldDisplayUnqualified'],
        'requireProgressionOrder': !exists(json, 'requireProgressionOrder') ? undefined : json['requireProgressionOrder'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': !exists(json, 'showQuestCompleteNotification') ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': !exists(json, 'questCompleteNotificationMessage') ? undefined : json['questCompleteNotificationMessage'],
        'questReset': QuestResetFromJSON(json['questReset']),
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(QuestConfigMilestoneFromJSON)),
        'prerequisites': !exists(json, 'prerequisites') ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'rewardConfigIds': !exists(json, 'rewardConfigIds') ? undefined : json['rewardConfigIds'],
        'isSponsored': !exists(json, 'isSponsored') ? undefined : json['isSponsored'],
        'sponsorName': !exists(json, 'sponsorName') ? undefined : json['sponsorName'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
        'rewardImage': !exists(json, 'rewardImage') ? undefined : json['rewardImage'],
        'startAt': !exists(json, 'startAt') ? undefined : json['startAt'],
        'endAt': !exists(json, 'endAt') ? undefined : json['endAt'],
    };
}

export function QuestConfigToJSON(value?: QuestConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'displayedOn': value.displayedOn === undefined ? undefined : ((value.displayedOn as Array<any>).map(QuestDisplayToJSON)),
        'shouldDisplayUnqualified': value.shouldDisplayUnqualified,
        'requireProgressionOrder': value.requireProgressionOrder,
        'name': value.name,
        'description': value.description,
        'isActive': value.isActive,
        'showQuestCompleteNotification': value.showQuestCompleteNotification,
        'questCompleteNotificationMessage': value.questCompleteNotificationMessage,
        'questReset': QuestResetToJSON(value.questReset),
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(QuestConfigMilestoneToJSON)),
        'prerequisites': value.prerequisites === undefined ? undefined : ((value.prerequisites as Array<any>).map(PrerequisiteToJSON)),
        'rewardConfigIds': value.rewardConfigIds,
        'isSponsored': value.isSponsored,
        'sponsorName': value.sponsorName,
        'logo': value.logo,
        'color': value.color,
        'externalUrl': value.externalUrl,
        'rewardImage': value.rewardImage,
        'startAt': value.startAt,
        'endAt': value.endAt,
    };
}


